'use client'
import { Box, IconButton } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import React, { useEffect, useState } from 'react'

const TransactionDisplay: React.FC = () => {
  const [transactionNo, setTransactionNo] = useState('')

  // Get transaction number from sessionStorage
  useEffect(() => {
    const storedTransactionNo = sessionStorage.getItem('transactionNo')
    if (storedTransactionNo && storedTransactionNo.trim() !== '') {
      setTransactionNo(storedTransactionNo)
    }

    // Listen for storage changes to update transaction number dynamically
    const handleStorageChange = () => {
      const updatedTransactionNo = sessionStorage.getItem('transactionNo')
      if (updatedTransactionNo && updatedTransactionNo.trim() !== '') {
        setTransactionNo(updatedTransactionNo)
      } else {
        setTransactionNo('')
      }
    }

    // Listen for custom storage events (for same-tab updates)
    window.addEventListener('storage', handleStorageChange)

    // Also listen for a custom event for same-tab sessionStorage updates
    window.addEventListener('transactionNoUpdated', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('transactionNoUpdated', handleStorageChange)
    }
  }, [])

  const handleQuestionIconClick = () => {
    // You can customize this behavior - for now, it shows an alert
    // You could also open a modal, navigate to a help page, etc.
    alert(
      `Transaction Number: ${transactionNo}\n\nThis is your unique transaction identifier for this printing session.`
    )
  }

  // Don't render if no transaction number
  if (!transactionNo) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '20px',
        left: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        padding: '12px 16px',
        borderRadius: '8px',
        zIndex: 9999, // High z-index to appear above all content
        backdropFilter: 'blur(4px)', // Add subtle blur effect
        border: '1px solid rgba(255, 255, 255, 0.1)' // Subtle border
      }}
    >
      <Box
        sx={{
          color: '#FFF',
          fontSize: '16px',
          fontFamily: 'AnekOdia, Arial, sans-serif',
          fontWeight: '500'
        }}
      >
        Transaction no.: {transactionNo}
      </Box>
      <IconButton
        onClick={handleQuestionIconClick}
        sx={{
          color: 'var(--TextYellow, #F9CB13)',
          padding: '4px',
          '&:hover': {
            backgroundColor: 'rgba(249, 203, 19, 0.1)',
            transform: 'scale(1.1)'
          },
          transition: 'all 0.2s ease-in-out'
        }}
        size='small'
      >
        <HelpOutlineIcon fontSize='small' />
      </IconButton>
    </Box>
  )
}

export default TransactionDisplay
